"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ComparisonToolsTeaser() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="comparison-tools-teaser" className="section-light overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-0 min-h-[60vh] md:min-h-[70vh]">
          {}
          <div ref={leftRef} className={`flex flex-col justify-center py-12 md:py-16 pr-0 md:pr-12 transition-all duration-[var(--duration-medium)] ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-foreground leading-tight mb-6">
              Compare Transport Costs
            </h2>
            <p className="text-lg md:text-xl text-muted-foreground leading-relaxed mb-4">
              Train vs Bus vs Carshare
            </p>
            <p className="text-base md:text-lg text-muted-foreground leading-relaxed mb-6">
              Save money on every journey across France. Our comparison tools
              help you find the cheapest route instantly.
            </p>
            <ul className="space-y-3 text-foreground">
              <li className="flex items-start gap-3">
                <span className="text-accent text-xl">•</span>
                <span className="text-base md:text-lg">
                  Real-time price comparisons
                </span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-accent text-xl">•</span>
                <span className="text-base md:text-lg">
                  Transparent cost breakdowns
                </span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-accent text-xl">•</span>
                <span className="text-base md:text-lg">
                  Updated daily for accuracy
                </span>
              </li>
            </ul>
          </div>

          {}
          <div ref={rightRef} className={`relative flex items-center justify-center bg-primary py-12 md:py-16 px-8 md:px-12 rounded-lg md:rounded-none transition-all duration-[var(--duration-medium)] group hover:bg-primary-hover ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <div className="text-center z-10">
              <Link to="/ComparisonToolsPage">
                <Button size="lg" className="btn-primary text-lg px-8 py-4 shadow-medium group-hover:shadow-strong transition-all duration-[var(--duration-fast)]">
                  Try the Tool
                </Button>
              </Link>
              <p className="text-foreground-primary/90 text-sm mt-4">
                Free to use, no sign-up required
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}